import { render, staticRenderFns } from "./liveExam.vue?vue&type=template&id=260131ff&scoped=true"
import script from "./liveExam.vue?vue&type=script&lang=js"
export * from "./liveExam.vue?vue&type=script&lang=js"
import style0 from "./liveExam.vue?vue&type=style&index=0&id=260131ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260131ff",
  null
  
)

export default component.exports